

























































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
// import key from '@/libs/filters/key';
import { updateSchool, getOrgAssignActivation, resetAccountPassword } from '@/api/school';

  // computed: {
  //   // ...mapState({
  //   //   accountId: state => state.user.id
  //   // }),
  //   form() {
  //     let opt = this.info
  //     opt.cuStomerType += ''
  //     return opt
  //   }
  // }


@Component({
  components: {
    AllotDialog: () => import('./allot-dialog.vue')
  }
})
export default class Detail extends Vue {
  private dialogVisible = false
  private codeList = [] // 总校激活码列表
  private form = {}
  private ifDisabled = true

  @Prop({
    type: Object,
    default() {
      return {
        id: '',
        name: '',
        status: '',
        cuStomerType: '',
        contactname: '',
        contactphone: '',
        adminemail: '',
        address: '',
        surplusCoursePackage: '',
        totalCoursePackage: '',
        teacherLimit: '',
        bindCount: '' // 剩余激活码数量
      };
    }
  })
  info!: any;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleClose!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getDetail!: Function;

  @Watch("info")
  infoChange(newVal: Object, oldVal: Object) {
    this.form = newVal
    // console.log(this.form)
  }


  async save() {
    await this.updateOrgInfo()
    await this.getData()
    this.handleClose();
  }
  async updateOrgInfo() {
    try {
      await updateSchool(this.form);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  reset() {
    this.$confirm(
      '您确定需要重置该账号的密码吗？重置后密码为123456',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
      .then(async () => {
        await this.resetAccountPassword();
        this.$message.success('账号密码重置成功');
      })
      .catch(() => {});
  }
  // 分配激活码
  private allotCode(val: any) {
    this.getOrgAssignActivation(val);
    // this.handleClose();
    (this.$refs.allotDialog as any).dialogVisible = true
  }
  async resetAccountPassword() {
    try {
      // await resetAccountPassword({ accountId: this.accountId });
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  // 校区查看总校可分配的激活码列表
  async getOrgAssignActivation(val: any) {
    try {
      // let parentId = this.$route.params.id
      // let parentId = this.form.parentId
      // console.log(val)
      let res: any = await getOrgAssignActivation({ parentId: val });
      this.codeList = res
      // console.log(this.codeList)
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}
